import { defineNuxtPlugin } from '#app/nuxt'
import { LazySvgoAdd, LazySvgoAddFile, LazySvgoArrowDown, LazySvgoArrowLeft, LazySvgoArrowRight, LazySvgoArrowUp, LazySvgoBag, LazySvgoBaselinePlus, LazySvgoBeigeBag, LazySvgoCart, LazySvgoChat, LazySvgoCheck, LazySvgoCheckCircle, LazySvgoCheckMark, LazySvgoChevronDown, LazySvgoChevronLeft, LazySvgoChevronLeftThin, LazySvgoChevronLeftThinS, LazySvgoChevronNext, LazySvgoChevronPrev, LazySvgoChevronRight, LazySvgoChevronRightStep, LazySvgoChevronRightThin, LazySvgoChevronRightThinS, LazySvgoChevronUp, LazySvgoClose, LazySvgoDesignLink, LazySvgoDiamondFilter, LazySvgoDiamond, LazySvgoEmail, LazySvgoExit, LazySvgoExpandLess, LazySvgoExpandMore, LazySvgoEyeCrossed, LazySvgoEye, LazySvgoFaq, LazySvgoFileRemove, LazySvgoFileUpload, LazySvgoFilter, LazySvgoFourColumns, LazySvgoGlobalSearch, LazySvgoGrid, LazySvgoHeartBold, LazySvgoHeartRounded, LazySvgoHeart, LazySvgoInfoFilled, LazySvgoInfoThin, LazySvgoInfo, LazySvgoInfo2, LazySvgoLabFilter, LazySvgoLabel, LazySvgoLink, LazySvgoLock, LazySvgoMenu, LazySvgoMinus, LazySvgoOneColumn, LazySvgoOutlineMail, LazySvgoPhone, LazySvgoPlus, LazySvgoRadioChecked, LazySvgoRadioUnchecked, LazySvgoReload, LazySvgoReturn, LazySvgoReviewRing, LazySvgoSaleLabelPdp, LazySvgoSaleLabel, LazySvgoSearchNoResults, LazySvgoSearch, LazySvgoSettings, LazySvgoShare, LazySvgoShipping, LazySvgoSocialLogoApple, LazySvgoSocialLogoFacebook, LazySvgoSocialLogoGoogle, LazySvgoSpin, LazySvgoStar, LazySvgoStarFilled, LazySvgoStarOutlined, LazySvgoStepDiamond, LazySvgoStepRing, LazySvgoStoneShapeAsscher, LazySvgoStoneShapeBaguette, LazySvgoStoneShapeCushion, LazySvgoStoneShapeEmerald, LazySvgoStoneShapeHeart, LazySvgoStoneShapeMarquise, LazySvgoStoneShapeOval, LazySvgoStoneShapePear, LazySvgoStoneShapePrincess, LazySvgoStoneShapeRadiant, LazySvgoStoneShapeRound, LazySvgoStoneShapeTaperedBaguette, LazySvgoStoneShapeTriangle, LazySvgoStoneShapeTrillion, LazySvgoThreeDots, LazySvgoTrash, LazySvgoTruckRed, LazySvgoTruck, LazySvgoTwoColumns, LazySvgoUserCircle, LazySvgoUser, LazySvgoWarning } from '#components'
const lazyGlobalComponents = [
  ["SvgoAdd", LazySvgoAdd],
["SvgoAddFile", LazySvgoAddFile],
["SvgoArrowDown", LazySvgoArrowDown],
["SvgoArrowLeft", LazySvgoArrowLeft],
["SvgoArrowRight", LazySvgoArrowRight],
["SvgoArrowUp", LazySvgoArrowUp],
["SvgoBag", LazySvgoBag],
["SvgoBaselinePlus", LazySvgoBaselinePlus],
["SvgoBeigeBag", LazySvgoBeigeBag],
["SvgoCart", LazySvgoCart],
["SvgoChat", LazySvgoChat],
["SvgoCheck", LazySvgoCheck],
["SvgoCheckCircle", LazySvgoCheckCircle],
["SvgoCheckMark", LazySvgoCheckMark],
["SvgoChevronDown", LazySvgoChevronDown],
["SvgoChevronLeft", LazySvgoChevronLeft],
["SvgoChevronLeftThin", LazySvgoChevronLeftThin],
["SvgoChevronLeftThinS", LazySvgoChevronLeftThinS],
["SvgoChevronNext", LazySvgoChevronNext],
["SvgoChevronPrev", LazySvgoChevronPrev],
["SvgoChevronRight", LazySvgoChevronRight],
["SvgoChevronRightStep", LazySvgoChevronRightStep],
["SvgoChevronRightThin", LazySvgoChevronRightThin],
["SvgoChevronRightThinS", LazySvgoChevronRightThinS],
["SvgoChevronUp", LazySvgoChevronUp],
["SvgoClose", LazySvgoClose],
["SvgoDesignLink", LazySvgoDesignLink],
["SvgoDiamondFilter", LazySvgoDiamondFilter],
["SvgoDiamond", LazySvgoDiamond],
["SvgoEmail", LazySvgoEmail],
["SvgoExit", LazySvgoExit],
["SvgoExpandLess", LazySvgoExpandLess],
["SvgoExpandMore", LazySvgoExpandMore],
["SvgoEyeCrossed", LazySvgoEyeCrossed],
["SvgoEye", LazySvgoEye],
["SvgoFaq", LazySvgoFaq],
["SvgoFileRemove", LazySvgoFileRemove],
["SvgoFileUpload", LazySvgoFileUpload],
["SvgoFilter", LazySvgoFilter],
["SvgoFourColumns", LazySvgoFourColumns],
["SvgoGlobalSearch", LazySvgoGlobalSearch],
["SvgoGrid", LazySvgoGrid],
["SvgoHeartBold", LazySvgoHeartBold],
["SvgoHeartRounded", LazySvgoHeartRounded],
["SvgoHeart", LazySvgoHeart],
["SvgoInfoFilled", LazySvgoInfoFilled],
["SvgoInfoThin", LazySvgoInfoThin],
["SvgoInfo", LazySvgoInfo],
["SvgoInfo2", LazySvgoInfo2],
["SvgoLabFilter", LazySvgoLabFilter],
["SvgoLabel", LazySvgoLabel],
["SvgoLink", LazySvgoLink],
["SvgoLock", LazySvgoLock],
["SvgoMenu", LazySvgoMenu],
["SvgoMinus", LazySvgoMinus],
["SvgoOneColumn", LazySvgoOneColumn],
["SvgoOutlineMail", LazySvgoOutlineMail],
["SvgoPhone", LazySvgoPhone],
["SvgoPlus", LazySvgoPlus],
["SvgoRadioChecked", LazySvgoRadioChecked],
["SvgoRadioUnchecked", LazySvgoRadioUnchecked],
["SvgoReload", LazySvgoReload],
["SvgoReturn", LazySvgoReturn],
["SvgoReviewRing", LazySvgoReviewRing],
["SvgoSaleLabelPdp", LazySvgoSaleLabelPdp],
["SvgoSaleLabel", LazySvgoSaleLabel],
["SvgoSearchNoResults", LazySvgoSearchNoResults],
["SvgoSearch", LazySvgoSearch],
["SvgoSettings", LazySvgoSettings],
["SvgoShare", LazySvgoShare],
["SvgoShipping", LazySvgoShipping],
["SvgoSocialLogoApple", LazySvgoSocialLogoApple],
["SvgoSocialLogoFacebook", LazySvgoSocialLogoFacebook],
["SvgoSocialLogoGoogle", LazySvgoSocialLogoGoogle],
["SvgoSpin", LazySvgoSpin],
["SvgoStar", LazySvgoStar],
["SvgoStarFilled", LazySvgoStarFilled],
["SvgoStarOutlined", LazySvgoStarOutlined],
["SvgoStepDiamond", LazySvgoStepDiamond],
["SvgoStepRing", LazySvgoStepRing],
["SvgoStoneShapeAsscher", LazySvgoStoneShapeAsscher],
["SvgoStoneShapeBaguette", LazySvgoStoneShapeBaguette],
["SvgoStoneShapeCushion", LazySvgoStoneShapeCushion],
["SvgoStoneShapeEmerald", LazySvgoStoneShapeEmerald],
["SvgoStoneShapeHeart", LazySvgoStoneShapeHeart],
["SvgoStoneShapeMarquise", LazySvgoStoneShapeMarquise],
["SvgoStoneShapeOval", LazySvgoStoneShapeOval],
["SvgoStoneShapePear", LazySvgoStoneShapePear],
["SvgoStoneShapePrincess", LazySvgoStoneShapePrincess],
["SvgoStoneShapeRadiant", LazySvgoStoneShapeRadiant],
["SvgoStoneShapeRound", LazySvgoStoneShapeRound],
["SvgoStoneShapeTaperedBaguette", LazySvgoStoneShapeTaperedBaguette],
["SvgoStoneShapeTriangle", LazySvgoStoneShapeTriangle],
["SvgoStoneShapeTrillion", LazySvgoStoneShapeTrillion],
["SvgoThreeDots", LazySvgoThreeDots],
["SvgoTrash", LazySvgoTrash],
["SvgoTruckRed", LazySvgoTruckRed],
["SvgoTruck", LazySvgoTruck],
["SvgoTwoColumns", LazySvgoTwoColumns],
["SvgoUserCircle", LazySvgoUserCircle],
["SvgoUser", LazySvgoUser],
["SvgoWarning", LazySvgoWarning],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
